import axios from 'axios';

const resolvedBaseURL = (() => {
  const envBase = (process.env.REACT_APP_API_BASE || '').trim();
  if (!envBase) {
    throw new Error('REACT_APP_API_BASE is required. Configure the correct API origin in environment variables.');
  }
  return envBase;
})();

const api = axios.create({
  baseURL: resolvedBaseURL,
});

// Endpoints that must never attach Authorization
const NO_AUTH_PATHS = ['/chat/', '/login/', '/public/site/', '/widget/chat-handover/', '/widget/config/'];

api.interceptors.request.use((config) => {
  const url = config.url || '';
  if (process.env.NODE_ENV === 'development') {
    const fullUrl = `${config.baseURL || resolvedBaseURL}${url}`;
    // eslint-disable-next-line no-console
    console.debug('[api] request', config.method?.toUpperCase(), fullUrl, config.data || config.params || {});
  }

  if (config.headers && config.headers['X-Bypass-Auth'] === '1') {
    if (config.headers.Authorization) delete config.headers.Authorization;
    return config;
  }

  if (NO_AUTH_PATHS.some((p) => url.includes(p))) {
    if (config.headers?.Authorization) delete config.headers.Authorization;
    return config;
  }

  const access = localStorage.getItem('access');
  if (access && config.headers) {
    config.headers.Authorization = `Bearer ${access}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const suppressToast = Boolean(error?.config?.suppressToast);
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.detail ||
      error?.message ||
      'Request failed.';
    if (typeof window !== 'undefined' && status !== 401 && !suppressToast) {
      window.dispatchEvent(
        new CustomEvent('app:toast', {
          detail: { message: String(message), variant: 'danger' },
        })
      );
    }
    return Promise.reject(error);
  }
);

export default api;
